// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.readme {
    padding: 2.5rem;
    background-color: #212529;
    color: #dee2e6;
}

.readme table {
    border: 2px solid rgb(136, 136, 136);
    margin: 1rem;
    min-width: 250px;
    float: left;
}

.readme hr {
    clear: both;
}

.readme thead:first-of-type {
    border-bottom-width: 2px;
  }

.readme td:first-of-type, .readme th:first-of-type{
    border: 0;
    border-right: 2px solid rgb(136, 136, 136);
    font-weight: bold;
    width: 80px;
}

.readme th{
    padding: 0.3rem;
}

.readme td{
    padding: 0.3rem;
    border: 1px solid rgb(136, 136, 136);
}

.image-container {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    gap: 1rem;
}

.image-container img {
    width: 100%;
    max-width: 500px;
    border: 2px solid #629df7;
    border-radius: 15px;
}

.image-container img:hover {
    outline: 2px solid #125dcc;
    border-color: #125dcc;
}

.image-container figcaption {
 text-align: center;
 color: #7c858d;
 font-size: 0.9rem;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Landingpage/Landingpage.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,wBAAwB;EAC1B;;AAEF;IACI,SAAS;IACT,0CAA0C;IAC1C,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,iBAAiB;AAClB","sourcesContent":[".readme {\r\n    padding: 2.5rem;\r\n    background-color: #212529;\r\n    color: #dee2e6;\r\n}\r\n\r\n.readme table {\r\n    border: 2px solid rgb(136, 136, 136);\r\n    margin: 1rem;\r\n    min-width: 250px;\r\n    float: left;\r\n}\r\n\r\n.readme hr {\r\n    clear: both;\r\n}\r\n\r\n.readme thead:first-of-type {\r\n    border-bottom-width: 2px;\r\n  }\r\n\r\n.readme td:first-of-type, .readme th:first-of-type{\r\n    border: 0;\r\n    border-right: 2px solid rgb(136, 136, 136);\r\n    font-weight: bold;\r\n    width: 80px;\r\n}\r\n\r\n.readme th{\r\n    padding: 0.3rem;\r\n}\r\n\r\n.readme td{\r\n    padding: 0.3rem;\r\n    border: 1px solid rgb(136, 136, 136);\r\n}\r\n\r\n.image-container {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    gap: 1rem;\r\n}\r\n\r\n.image-container img {\r\n    width: 100%;\r\n    max-width: 500px;\r\n    border: 2px solid #629df7;\r\n    border-radius: 15px;\r\n}\r\n\r\n.image-container img:hover {\r\n    outline: 2px solid #125dcc;\r\n    border-color: #125dcc;\r\n}\r\n\r\n.image-container figcaption {\r\n text-align: center;\r\n color: #7c858d;\r\n font-size: 0.9rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
